import type { RiskObjectGroups, ROMiscMinimal } from '../types';

const GROUPS: RiskObjectGroups<ROMiscMinimal> = [
  {
    title: 'RO_SECTION_OVERVIEW',
    properties: [
      {
        label: 'RO_MISC_NAME',
        getValue: (misc) => misc.name,
      },
      {
        label: 'RO_MISC_TYPE',
        getValue: (misc) => misc.type,
      },
      // {
      //   label: 'RO_MISC_AMOUNT',
      //   getValue: (misc) => misc.amount_of_objects,
      // },
      // {
      //   label: 'RO_MISC_VALUE',
      //   getValue: (misc) => formatCurrency(misc.value),
      // },
      // {
      //   label: 'RO_MISC_DESCRIPTION',
      //   getValue: (misc) => misc.description,
      // },
    ],
  },
];

export default GROUPS;
